import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { RelatedTransactionsAdapter } from '../adapters/relatedTransactionsAdapter';
import { IRelatedTransactionsDetail } from '../domains/entities/relatedTransaction';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 関連取引データを取得するユースケース
 */
export class GetRelatedTransactionsDetailUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 関連取引データを取得する
   * @param aggregateBusinessId - 集計取引ID
   * @param receiptMonthOffset - 受領月オフセット（Nヶ月前内示を指定する）
   * @returns 関連取引データ
   */
  public async execute(
    aggregateBusinessId: string,
    receiptMonthOffset: number
  ): Promise<INetworkResult<IRelatedTransactionsDetail, IError>> {
    try {
      // 日付範囲を計算（現在月から過去1年から未来2年まで）
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1;

      const startYearMonth = DateService.getShiftedIYearMonthByMonths(currentYear, currentMonth, -12);
      const endYearMonth = DateService.getShiftedIYearMonthByMonths(currentYear, currentMonth, 24);

      // リポジトリ経由でAPI呼び出し
      const networkResult = await this.repository.getRelatedTransactionsDetail(
        aggregateBusinessId,
        startYearMonth.year,
        startYearMonth.month,
        endYearMonth.year,
        endYearMonth.month,
        receiptMonthOffset
      );

      // レスポンスからデータを取得し、ドメイン型に変換
      if (networkResult.status.type === 'success') {
        const adaptedData = RelatedTransactionsAdapter.adapt(networkResult.status.data, startYearMonth, endYearMonth);
        return {
          status: {
            type: 'success',
            data: adaptedData,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: networkResult.status.error,
          },
        };
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: error instanceof Error ? error.message : 'データの取得に失敗しました',
          },
        },
      };
    }
  }
}
